import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleSection from '../../client_customizations/components/CollapsibleSection/CollapsibleSection';

import './FaqComponent.scss';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { FormattedMessage } from 'react-intl';

const FaqComponent = ({ faqs, language }) => {
  if (!faqs)
    return (
      <div className="spinner-container">
        <LoadingSpinner />
      </div>
    );

  const style = {
    fontFamily: 'ZillaSlab',
    color: '#142C41 !important',
    fontWeight: 'bold',
  };

  return (
    <div className="CollapsibleSectionContainer">
      {faqs.map((content, index) => (
        <CollapsibleSection
          key={`article-${
            language === 'EN' ? content.section : content.sectionSP
          }-${index}`}
          headLine={
            language === 'EN' ? content.articleTitle : content.articleTitleSP
          }
        >
          <FormattedMessage
            id={`article-${index}`}
            defaultMessage={
              language === 'EN' ? content.articleBody : content.articleBodySP
            }
            values={{
              b: (...msg) => <b style={style}>{msg}</b>,
              u: (...msg) => <u>{msg}</u>,
              i: (...msg) => <i>{msg}</i>,
              br: () => <br />,
              h1: (...msg) => <p style={{ ...style, fontSize: 20 }}>{msg}</p>,
              h2: (...msg) => <p style={{ ...style, fontSize: 18 }}>{msg}</p>,
              h3: (...msg) => <p style={{ ...style, fontSize: 16 }}>{msg}</p>,
              a: (chunks) => (
               <a href={content.link} target="_blank" rel="noopener noreferrer">
                 {chunks}
               </a>
             ),
              a1: (chunks) => (
               <a href={content.firstLink} target="_blank" rel="noopener noreferrer">
                 {chunks}
               </a>
             ),
             a2: (chunks) => (
               <a href={content.secondLink} target="_blank" rel="noopener noreferrer">
                 {chunks}
               </a>
             ),
            }}
          />
        </CollapsibleSection>
      ))}
    </div>
  );
};

export default FaqComponent;
FaqComponent.propTypes = {
  faqs: PropTypes.array,
  language: PropTypes.string,
};
